import React, { useState, useImperativeHandle } from "react";
import { Modal, Button } from "antd";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";

interface DonateConfirmModalProps {
  onRef: React.RefObject<any>;
  onConfirm: () => void;
  inputValue: number;
}

const DonateConfirmModal = ({ onRef, onConfirm, inputValue }: DonateConfirmModalProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { isMobile } = useAppSelector((state: RootState) => state.app);

  useImperativeHandle(onRef, () => ({
    setOpen,
  }));

  const clickConfirm = () => {
    onConfirm?.();
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
      centered
      closable={false}
      width={isMobile ? "94vw" : 678}
      className="custom-donate-modal"
    >
      <div className="relative">
        <Image
          src="/images/csr/donation_dialog_bg.webp"
          alt="donation"
          width={isMobile ? 362 : 634}
          height={isMobile ? 160 : 291}
          className="absolute left-1/2 z-20 -translate-x-1/2"
          style={{ top: isMobile ? "-60px" : "-100px" }}
        />

        <div
          className="custom-top-shape relative z-10"
          style={{
            height: isMobile ? 100 : 180, // ✅ clip-path 高度缩小
          }}
        />

        <div
          className={`relative z-0 rounded-b-xl bg-white px-6 pb-8 text-center ${
            isMobile ? "pt-2" : "pt-10"
          }`}
        >
          <h2 className="mb-3 text-xl font-semibold">{t("csr.donation_confirm")}</h2>
          <p className={`text-stone-800 ${isMobile ? "text-sm" : "text-base"}`}>
            {t("csr.donation_confirm_desc_1")}
            {inputValue}（{(inputValue / 1000).toFixed(2)} USD）
            <p>{t("csr.donation_confirm_desc_2")}</p>
          </p>
          <div className={`flex justify-center gap-4 ${isMobile ? "mt-8" : "mt-10 "}`}>
            <Button type="default" onClick={() => setOpen(false)} size="large" className="bg-white">
              {t("common.cancel")}
            </Button>
            <Button type="primary" onClick={clickConfirm} size="large">
              {t("common.confirm")}
            </Button>
          </div>
        </div>

        <style jsx global>{`
          .custom-donate-modal .ant-modal-content {
            background-color: transparent !important;
            box-shadow: none !important;
            padding: 0 !important;
          }

          .custom-top-shape {
            background-color: white;
            clip-path: polygon(0 100%, 0 35%, 50% 0, 100% 35%, 100% 100%);
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
          }
        `}</style>
      </div>
    </Modal>
  );
};

export default DonateConfirmModal;
